// KP-75 step 1 — org-wide inbox for employee-submitted questions
// (internal-team-mode). Same admin-dashboard/organizations/:organizationId
// controller family as onboarding.ts, guarded by CRUDChecklists on the
// backend. Department-manager routing/notifications are steps 2/3 — out of
// scope here.
export const studentQuestionsApiHandler = {
  getQuestions: {
    method: 'GET',
    path: (payload: { orgId: number | string }) =>
      `admin-dashboard/organizations/${payload.orgId}/student-questions`,
    params: {} as { status?: 'OPEN' | 'ANSWERED' },
  },
  answerQuestion: {
    method: 'PATCH',
    path: (payload: { orgId: number | string; questionId: number | string }) =>
      `admin-dashboard/organizations/${payload.orgId}/student-questions/${payload.questionId}/answer`,
  },
};
